import { ProgramBundleInfoHeader } from "@modules/programBundle/components/programBundleInfoHeader"
import { ProgramBundleEntity } from "@modules/programBundle/entities/programBundleEntity"
import { ProgramInfoHeader } from "@modules/programs/components/programInfoHeader"
import { UserProgramDetailsEntity } from "@modules/programs/entities/userProgramDetailsEntity"
import { EmbeddedCheckout, EmbeddedCheckoutProvider } from "@stripe/react-stripe-js"
import { type Stripe } from "@stripe/stripe-js"

type CheckoutContainerProps = {
  stripePromise: Stripe
  clientSecret: string
  program?: UserProgramDetailsEntity | ProgramBundleEntity
  className?: string
  onCompleteCheckout?: () => void
} & React.ComponentProps<"div">

export function CheckoutContainer({
  clientSecret,
  stripePromise,
  program,
  className,
  onCompleteCheckout,
  ...props
}: CheckoutContainerProps) {
  const defaultClassName = "flex flex-col grow-1"
  return (
    <EmbeddedCheckoutProvider stripe={stripePromise} options={{ clientSecret, onComplete: onCompleteCheckout }}>
      <div className={className ?? defaultClassName} {...props}>
        {program &&
          (program instanceof ProgramBundleEntity ? (
            <ProgramBundleInfoHeader programBundleId={program.id} />
          ) : (
            <ProgramInfoHeader programId={program.id} />
          ))}
        <div className={`pt-8 pb-6`}>
          <EmbeddedCheckout />
        </div>
      </div>
    </EmbeddedCheckoutProvider>
  )
}
